// extracted by mini-css-extract-plugin
module.exports = {"hour":"dateBody_hour__20glY"};